<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Add bank
    </ng-container>

    <ng-container
        dialog-process-in-progress

        *ngIf="bankAccountsForm && bankAccountsForm.form"
    >
        <form [formGroup]="bankAccountsForm.form" autocomplete="off">
            <app-select
                [formControlName]="bankAccountsForm.controls.accountType.name"
                [control]="bankAccountsForm.controls.accountType"
            ></app-select>

            <ng-container *ngIf="!isCryptoWallet">
                <app-panel-input
                    *ngIf="bankAccountsForm.controls.iban"
                    [formControlName]="bankAccountsForm.controls.iban.name"
                    [control]="bankAccountsForm.controls.iban"
                ></app-panel-input>
                <app-panel-input
                    *ngIf="bankAccountsForm.controls.accountNumber"
                    [formControlName]="bankAccountsForm.controls.accountNumber.name"
                    [control]="bankAccountsForm.controls.accountNumber"
                ></app-panel-input>
                <app-panel-input
                    [formControlName]="bankAccountsForm.controls.bankName.name"
                    [control]="bankAccountsForm.controls.bankName"
                ></app-panel-input>
                <app-panel-input
                    *ngIf="bankAccountsForm.controls.bic"
                    [formControlName]="bankAccountsForm.controls.bic.name"
                    [control]="bankAccountsForm.controls.bic"
                ></app-panel-input>
                <app-panel-input
                    *ngIf="bankAccountsForm.controls.sortCode"
                    [formControlName]="bankAccountsForm.controls.sortCode.name"
                    [control]="bankAccountsForm.controls.sortCode"
                ></app-panel-input>
                <app-country-autocomplete
                    [formControlName]="bankAccountsForm.controls.beneficiaryBankCountry.name"
                    [control]="bankAccountsForm.controls.beneficiaryBankCountry"
                ></app-country-autocomplete>
                <app-panel-input
                    [formControlName]="bankAccountsForm.controls.beneficiaryBankAddress.name"
                    [control]="bankAccountsForm.controls.beneficiaryBankAddress"
                ></app-panel-input>
                <app-select
                    [formControlName]="bankAccountsForm.controls.currency.name"
                    [control]="bankAccountsForm.controls.currency"
                ></app-select>
            </ng-container>

            <ng-container *ngIf="isCryptoWallet">
                <app-panel-input
                    [formControlName]="bankAccountsForm.controls.crypto_wallet_name.name"
                    [control]="bankAccountsForm.controls.crypto_wallet_name"
                ></app-panel-input>
                <app-panel-input
                    [formControlName]="bankAccountsForm.controls.crypto_wallet_address.name"
                    [control]="bankAccountsForm.controls.crypto_wallet_address"
                ></app-panel-input>
                <app-select
                    [formControlName]="bankAccountsForm.controls.crypto_network_code.name"
                    [control]="bankAccountsForm.controls.crypto_network_code"
                ></app-select>
                <app-select
                    [formControlName]="bankAccountsForm.controls.crypto_code.name"
                    [control]="bankAccountsForm.controls.crypto_code"
                ></app-select>
                <app-select
                    [formControlName]="bankAccountsForm.controls.crypto_wallet_type.name"
                    [control]="bankAccountsForm.controls.crypto_wallet_type"
                ></app-select>
            </ng-container>
        </form>

        <div class="mt-3">
            <app-upload-document
                (documentUploaded)="bankAccountsForm.documentFile = $event"
                [documentErrorSubject]="bankAccountsForm.documentErrorsSubject"
                [client]="data.client"
            ></app-upload-document>
        </div>
    </ng-container>
</app-dialog>
